// extracted by mini-css-extract-plugin
export default {"details":"UserDetails_details__gLfJs","content":"UserDetails_content__ny95O","emptyMessage":"UserDetails_emptyMessage__N7Kbj"};